module.exports = __webpack_public_path__ + "static/media/0.b6f1bbd7.png";